import { getRoot, types } from 'mobx-state-tree';
import Paths from '../types/Paths';
import generatePath from '../util/generatePath';
import _ from 'lodash';
import { SectionStatusTypeType } from '../types/SectionStatusType';
import { SectionIntegrationTypeType } from '../types/SectionIntegrationType';
import LinkType from '../types/LinkType';

const Section = types
  .model('Section', {
    id: types.identifierNumber,
    slug: types.string,
    display_name: types.string,
    link_type: types.maybeNull(types.string),
    blocked_categories: types.array(types.number),
    main_categories: types.array(types.number),
    content_html: types.maybeNull(types.string),
    configurations: types.frozen(),
    status: SectionStatusTypeType,
    SEO_title: types.maybeNull(types.string),
    SEO_description: types.maybeNull(types.string),
    integration_type: types.maybeNull(SectionIntegrationTypeType),
    integration_feed_url: types.maybeNull(types.string),
    integration_api_key: types.maybeNull(types.string),
    footer_description_html: types.maybeNull(types.string),
    name_in_navigation: types.maybeNull(types.string)
  })
  .views((self) => {
    return {
      get blockedCategoriesDict() {
        return _.keyBy(self.blocked_categories, (categoryId) => categoryId);
      },
      get mainCategoryIds() {
        return self.main_categories.filter((categoryId) => {
          return !self.blockedCategoriesDict[categoryId];
        });
      },
      get mainCategories() {
        const categoryStore = getRoot(self).categoryStore;
        return categoryStore.flattenedCategories.filter((category) =>
          self.mainCategoryIds.includes(category.id)
        );
      },
      get path() {
        if (
          self.link_type === LinkType.EXTERNAL_LINK ||
          self.link_type === LinkType.INTERNAL_LINK
        ) {
          return self.slug;
        }

        if (self.slug && self.slug.length > 0) {
          return generatePath(Paths.Section, {
            section: self.slug
          });
        }
      },
      get breadcrumbs() {
        return [
          {
            text: self.display_name,
            url: self.path
          }
        ];
      },
      get mainCategoriesDict() {
        return _.keyBy(self.mainCategoryIds, (categoryId) => categoryId);
      },
      get navigationName() {
        return self.name_in_navigation && self.name_in_navigation.length > 0
          ? self.name_in_navigation
          : self.display_name;
      },
      hasMainCategory(categoryId) {
        return _.has(self.mainCategoriesDict, categoryId);
      },
      includesCategory(category) {
        return (
          self.hasMainCategory(category.mainCategory.id) &&
          !_.has(self.blockedCategoriesDict, category.id)
        );
      }
    };
  });

export default Section;



// WEBPACK FOOTER //
// ./src/models/Section.js